import React, { useEffect, useState } from 'react';
import { MetricSection } from '../Metrics/MetricSection';
import { InBStatus } from '../InterfacesAndBottlers/InBStatus';
import redBG from '../../../../Assets/BG-DASHBOARDTILE-1.svg?url';
import orangeBG from '../../../../Assets/BG-DASHBOARDTILE-2.svg?url';
import blueBG from '../../../../Assets/BG-DASHBOARDTILE-3.svg?url';
import brownBG from '../../../../Assets/BG-DASHBOARDTILE-4.svg?url';
import styles from './Dashboard.module.css';
import { Header } from '../header/Header';
import { DashboardSidebar } from '../DashboardSidebar/DashboardSidebar';
import { grafanaApiService } from 'services/grafanaApiService';
import { getIdTokenFromMsal } from '../../../../utils/auth';
import { useMsal } from "@azure/msal-react";
import {
  InteractionStatus,
} from "@azure/msal-browser";

export const Dashboard = ({ serviceKey }) => {
  const [error, setError] = useState(null);
  const [dashboardData, setDashboardData] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { instance, accounts, inProgress } = useMsal();
  useEffect(() => {
    console.log('Dashboard useEffect triggered:', {
      serviceKey,
      inProgress,
      accounts: accounts?.length,
      hasInstance: !!instance
    });

    const fetchDashboards = async () => {
      try {
        const idToken = await getIdTokenFromMsal(instance, accounts);
        if (!idToken) {
          setError('User is not authenticated (ID token missing)');
          return;
        }

        const data = await grafanaApiService.getDashboardManifest(idToken);

        setDashboardData(data);
      } catch (error) {
        console.error('fetchDashboards error:', error);
        setError('Failed to load dashboard');
      }
    };

    if (inProgress === InteractionStatus.None) {
      fetchDashboards();
    } else {
      console.log('Conditions not met for fetchDashboards:', {
        interactionStatus: inProgress,
        isNone: inProgress === InteractionStatus.None
      });
    }
  }, [instance, accounts, inProgress]);

  const metrics = [
    { label: 'Major Incidents', value: '3', background: redBG },
    { label: 'SLA Breaches (24h)', value: '2', background: orangeBG },
    { label: 'Emergency Changes(24h)', value: '1', background: blueBG },
    { label: 'Planned Changes(7d)', value: '12', background: brownBG }
  ];
  const InB = [
    { name: 'Service Health', value: 'View overall service health through key metrics', serviceKey: 'service-health' },
    { name: 'Incidents', value: 'Track incidents and response progress', serviceKey: 'cases' },
    { name: 'Changes', value: 'Monitor upcoming changes and change performance', serviceKey: 'changes' },
    { name: 'SLA and Reporting', value: 'Monitor SLA performance and compliance', serviceKey: 'sla-reporting' },
    { name: 'Service Requests', value: 'Track service requests and fulfillment', serviceKey: 'environment-performance' },
    { name: 'Problems and RCA', value: 'Review problem tickets and RCA summaries', serviceKey: 'problems-rca' },
    { name: 'Alerts and AIOPs', value: 'Intelligent alerting and automation (coming soon)', serviceKey: 'alerts-aiops' },
    { name: 'Projects', value: 'Project tracking and delivery metrics (coming soon)', serviceKey: 'projects' },
    { name: 'Governance', value: 'Governance framework and compliance dashboards (coming soon)', serviceKey: 'governance' },
    { name: 'Asset & Environment', value: 'Asset inventory and environment coverage insights (coming soon)', serviceKey: 'asset-environment' },
  ];

  return (
    <div className={styles.dashboardContainer}>
      <div className={styles.headerWrapper}>
        <Header
          title='Unified Service Insights'
          subtitle='Dashboards and analytics from your managed environment'
          onToggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
          rightActions={[
            { label: 'Wallboard', onClick: () => console.log('Wallboard') },
            { label: 'Interactive', onClick: () => console.log('Interactive') },
            { label: 'Auto-Rotate', onClick: () => console.log('Auto-Rotate') },
            { label: 'Pause', onClick: () => console.log('Pause') },
            { label: 'FullScreen', onClick: () => console.log('FullScreen') }
          ]}
          notifications={{ count: 3, onClick: () => console.log('Notifications clicked!') }}
          actions={[
            { label: 'Refresh', onClick: () => console.log('Refresh') },
            { label: 'Export', onClick: () => console.log('Export') }
          ]}
        />
      </div>

      <div className={styles.mainWrapper}>
        <DashboardSidebar
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />

        <div className={styles.contentWrapper}>
          {/* <MetricSection metrics={metrics} /> */}
          <div className={styles.dashboardGrid}>
            <div className={styles.mainContent}></div>
          </div>
          <div className={styles.fullWidthSection}>
            <InBStatus InB={InB} onCloseSidebar={() => setIsSidebarOpen(false)} />
          </div>
        </div>
      </div>
    </div>
  );
}